/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wsnofriendstitle3Inputs */



/**
* | output |
* | --- |
* | "No new friends for you right now, but I'm still hunting. I'll ping you as soon as I find your people! 🔍✨" |
*
* @param {Wsnofriendstitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const wsnofriendstitle3 = /** @type {((inputs?: Wsnofriendstitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wsnofriendstitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No new friends for you right now, but I'm still hunting. I'll ping you as soon as I find your people! 🔍✨")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ahora mismo no tengo nuevos amigos para ti, pero sigo buscando. ¡Te aviso en cuanto encuentre a tu gente! 🔍✨")
	return /** @type {LocalizedString} */ ("Сейчас подходящих друзей для тебя нет, но я продолжаю поиск. Напишу сразу, как найду кого-то для тебя 🔍✨")
});
export { wsnofriendstitle3 as "wsNoFriendsTitle" }